import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import IconifyIcon from './wrappers/IconifyIcon';
import { API_TOKEN_KEY, ADMIN_DATA_KEY } from '../config/api';

const EVENT_NAME = 'admin:token-expired';

/**
 * Global modal shown when any API returns token_expired.
 * User stays on the current page until they click "Go to login page".
 */
export default function TokenExpiredModal() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleTokenExpired = () => setShow(true);
    window.addEventListener(EVENT_NAME, handleTokenExpired);
    return () => window.removeEventListener(EVENT_NAME, handleTokenExpired);
  }, []);

  const goToLogin = () => {
    localStorage.removeItem(API_TOKEN_KEY);
    localStorage.removeItem(ADMIN_DATA_KEY);
    window.location.href = '/login';
  };

  return (
    <Modal show={show} onHide={() => { }} centered backdrop="static" className="token-expired-modal">
      <Modal.Body className="text-center py-4 px-4">
        <div className="token-expired-modal__icon-wrapper rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center mb-3">
          <IconifyIcon icon="mdi:clock-alert-outline" className="text-primary" width={48} height={48} />
        </div>
        <h5 className="mb-2 fw-semibold">Session expired</h5>
        <p className="text-muted mb-4 mx-auto token-expired-modal__message">
          Your Current Session has been expired. Sign-In again to continue.
        </p>
        <Button variant="primary" size="lg" onClick={goToLogin} className="px-4">
          <IconifyIcon icon="mdi:login" width={20} height={20} className="me-2" />
          Go to Sign In page
        </Button>
      </Modal.Body>
    </Modal>
  );
}
